import { APP_NAME } from '../constants/app';

const fr = {
  common: {
    appName: APP_NAME,
    actions: {
      add: 'Ajouter',
      create: 'Créer',
      update: 'Mettre à jour',
      delete: 'Supprimer',
      cancel: 'Annuler',
      close: 'Fermer',
      previous: 'Précédente',
      next: 'Suivante',
      edit: 'Modifier',
      moveUp: 'Monter',
      moveDown: 'Descendre',
      renameCategory: 'Renommer la catégorie',
      remove: 'Retirer',
      save: 'Enregistrer',
      request: 'Demander',
      report: 'Signaler',
      accept: 'Accepter',
      decline: 'Refuser',
      logout: 'Se déconnecter',
      resend: 'Renvoyer',
      openLink: 'Ouvrir le lien',
    },
    languages: {
      label: 'Langue',
      en: 'Anglais',
      fr: 'Français',
    },
    statuses: {
      accepted: 'Accepté',
      approved: 'Approuvé',
      pending: 'En attente',
      rejected: 'Refusé',
      cancelled: 'Annulé',
      active: 'Actif',
      resolved: 'Résolue',
      inProgress: 'En cours',
      reported: 'Signalé',
      purchased: 'Acheté',
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Élevée',
    },
    fields: {
      name: 'Nom',
      title: 'Titre',
      shortDescription: 'Description courte',
      description: 'Description',
      email: 'Email',
      password: 'Mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom',
      address: 'Adresse',
      city: 'Ville',
      country: 'Pays',
      phone: 'Téléphone',
      notes: 'Notes',
      message: 'Message',
      location: 'Lieu',
      status: 'Statut',
      category: 'Catégorie',
      severity: 'Gravité',
      startDate: 'Date de début',
      endDate: 'Date de fin',
    },
    labels: {
      supportedFormats: 'Formats pris en charge : {{formats}}',
      currentPhotos: 'Photos actuelles',
      dragToReorder: 'Glissez pour réorganiser. La première photo est la couverture.',
      newPhotosToUpload: 'Nouvelles photos à téléverser',
      uncategorized: 'Sans catégorie',
      photoCount_one: '{{count}} photo',
      photoCount_other: '{{count}} photos',
      guestCount_one: '{{count}} invité',
      guestCount_other: '{{count}} invités',
      addedOn: 'Ajouté le {{date}}',
      invitedOn: 'Invité le {{date}}',
      reportedOn: 'Signalé le {{date}}',
      contribution: 'Contribution',
      contributionAmount: 'Montant de la contribution',
      contributionDescription: 'Description de la contribution',
      maxGuests: 'Nombre max. d\'invités',
      maxConsecutiveDays: 'Nombre max. de jours consécutifs',
      maxBookingLeadDays: "Délai max. de réservation (jours)",
      latitude: 'Latitude',
      longitude: 'Longitude',
      komootUrl: 'URL Komoot',
      estimatedPrice: 'Prix estimé',
      productUrl: 'URL du produit',
      houseName: 'Nom de la maison',
      numberOfGuests: "Nombre d'invités",
      availabilityRules: 'Règles de disponibilité',
      host: 'Hôte',
      members: 'Membres',
      menu: 'Menu',
      guests: 'Invités',
      guide: 'Guide',
      image: 'Image',
      imagePosition: 'Image {{current}} sur {{total}}',
      distanceKilometers: '{{value}} km',
    },
    roles: {
      owner: 'Propriétaire',
      host: 'Hôte',
      guest: 'Invité',
    },
    helpers: {
      optionalCoordinates: 'Coordonnées optionnelles pour la carte',
      invalidLatitude: 'La latitude doit être comprise entre -90 et 90',
      invalidLongitude: 'La longitude doit être comprise entre -180 et 180',
      contributionUsage: 'Expliquez comment la contribution sera utilisée',
      contributionPerStay: 'Coût par séjour (optionnel)',
      komootOptional: 'Lien optionnel vers un itinéraire Komoot',
      productUrlOptional: 'Lien optionnel vers une boutique en ligne',
      selectOrCreateCategory: 'Choisissez une catégorie existante ou saisissez-en une nouvelle',
    },
  },
  layout: {
    myHouses: 'Mes maisons',
    notifications: 'Notifications',
    accountMenuAria: "compte de l'utilisateur actuel",
    profile: 'Profil',
  },
  profile: {
    layoutTitle: 'Profil',
    title: 'Profil',
    subtitle: 'Consultez votre compte, la langue et votre activité dans les maisons partagées depuis un seul écran.',
    quickLinksTitle: 'Accès rapides',
    accountSecurityTitle: 'Sécurité du compte',
    preferencesTitle: 'Préférences',
    hostedHomes: 'Maisons hôte',
    visitingHomes: 'Maisons invité',
    pendingInvitations: 'Invitations en attente',
    languageHelper: "Changez instantanément la langue de l'interface pour votre session en cours.",
    goToHouses: 'Aller aux maisons',
    goToInvitations: 'Voir les invitations',
    signedInAs: `Connecté avec votre compte ${APP_NAME} actuel.`,
    failedFetch: 'Impossible de récupérer les données du profil',
    failedSave: "Impossible d'enregistrer les modifications du profil",
    failedAccountSave: "Impossible d'enregistrer les paramètres du compte",
    saveSuccess: 'Profil mis à jour avec succès',
    accountSaveSuccess: 'Paramètres du compte mis à jour avec succès',
    saving: 'Enregistrement...',
    resetProfile: 'Réinitialiser',
    sessionNote: "Le changement de langue s'applique immédiatement. Les changements de nom sont enregistrés sur votre compte.",
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    newPasswordHelper: 'Laissez vide si vous souhaitez seulement modifier votre adresse email.',
    saveAccountSettings: 'Enregistrer les paramètres du compte',
    passwordMismatch: 'Le nouveau mot de passe et sa confirmation ne correspondent pas',
  },
  auth: {
    login: {
      title: 'Bon retour',
      subtitle: 'Connectez-vous pour accéder à votre compte',
      submit: 'Se connecter',
      submitting: 'Connexion...',
      noAccount: "Vous n'avez pas de compte ?",
      signUp: 'Créer un compte',
      emailRequired: "L'email est obligatoire",
      invalidEmail: 'Veuillez saisir une adresse email valide',
      passwordRequired: 'Le mot de passe est obligatoire',
      passwordMin: 'Le mot de passe doit contenir au moins 6 caractères',
      failed: 'Connexion impossible. Vérifiez vos identifiants.',
      forgotPassword: 'Mot de passe oublié ?',
    },
    forgotPassword: {
      title: 'Réinitialiser le mot de passe',
      subtitle: 'Entrez votre email et nous vous enverrons un lien de réinitialisation.',
      submit: 'Envoyer le lien',
      submitting: 'Envoi...',
      success: 'Si un compte correspond à cet email, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception.',
      failed: 'Une erreur est survenue. Veuillez réessayer.',
      backToLogin: 'Retour à la connexion',
    },
    resetPassword: {
      title: 'Nouveau mot de passe',
      subtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      submit: 'Réinitialiser le mot de passe',
      submitting: 'Réinitialisation...',
      success: 'Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.',
      failed: 'Ce lien de réinitialisation est invalide ou a expiré.',
      goToLogin: 'Aller à la connexion',
    },
    register: {
      title: 'Créer un compte',
      subtitle: `Inscrivez-vous pour commencer avec ${APP_NAME}`,
      submit: "S'inscrire",
      submitting: 'Création du compte...',
      hasAccount: 'Vous avez déjà un compte ?',
      signIn: 'Se connecter',
      confirmPassword: 'Confirmer le mot de passe',
      firstNameRequired: 'Le prénom est obligatoire',
      firstNameMin: 'Le prénom doit contenir au moins 2 caractères',
      lastNameRequired: 'Le nom est obligatoire',
      lastNameMin: 'Le nom doit contenir au moins 2 caractères',
      emailRequired: "L'email est obligatoire",
      invalidEmail: 'Veuillez saisir une adresse email valide',
      passwordRequired: 'Le mot de passe est obligatoire',
      passwordMin: 'Le mot de passe doit contenir au moins 6 caractères',
      confirmPasswordRequired: 'Veuillez confirmer votre mot de passe',
      passwordsMismatch: 'Les mots de passe ne correspondent pas',
      failed: 'Impossible de créer le compte. Réessayez.',
    },
  },
  publicHome: {
    eyebrow: '{{appName}} signifie l\'hospitalité en Grec',
    hero: {
      title: 'Partagez votre maison avec vos proches dans un cadre soigné et serein.',
      subtitle:
        'Offrez une expérience premium autour de votre maison : organisez les disponibilités, préparez chaque séjour avec attention et gardez les bonnes informations parfaitement structurées.',
      primaryCta: 'Créer un compte',
      primaryCtaDetail: 'hôte ou invité',
      secondaryCta: 'Se connecter',
      supportingCopy: '{{appName}} vous aide à accueillir les personnes de confiance avec plus de clarté, plus d’élégance et moins de friction d’un séjour à l’autre.',
    },
    features: {
      guide: {
        title: 'Un guide maison soigné',
        description: 'Rassemblez consignes d’arrivée, règles de la maison, de contribution et réservation. Les bonnes adresses et contacts utiles dans un espace clair et élégant.',
      },
      planning: {
        title: 'Des disponibilités fluides à organiser',
        description: 'Coordonnez simplement le calendrier de la maison et les prochains séjours, sans dépendre d’échanges dispersés et de rappels de dernière minute.',
      },
      sharing: {
        title: 'Pensé pour un cercle de confiance',
        description: 'Partagez votre maison avec votre famille et vos amis grâce à un niveau d’accès adapté, dans un cadre à la fois personnel et rassurant.',
      },
    },
    preview: {
      overline: 'Ce que ça fait',
      title: 'Un espace maison premium conçu pour un partage de confiance.',
      description:
        'Au lieu de réécrire les mêmes messages à chaque visite, préparez un espace élégant et réutilisable pour les séjours en famille, entre amis, ou pour des invités choisis avec soin.',
      cards: {
        houseGuide: {
          title: 'Guide maison et recommandations de confiance',
          description: 'Gardez ensemble les adresses, les instructions, vos lieux préférés et les détails qui rendent l’arrivée simple et bien préparée.',
        },
        sharedPlanning: {
          title: 'Disponibilités et séjours partagés',
          description: 'Suivez qui vient, quand la maison est disponible et quelles activités ou préparatifs comptent pour un séjour fluide.',
        },
      },
      tipLabel: 'Pourquoi on l’utilise',
      tipTitle: 'Plus de confiance.',
      tipDescription: 'Vos proches savent où trouver les bonnes informations et votre maison reste simple à partager, avec soin et constance.',
    },
    bottomCta: {
      title: 'Créez un espace maison de confiance, puis réutilisez-le à chaque séjour en famille ou entre amis.',
      description: '',
      primaryCta: 'Créer un compte',
      primaryCtaDetail: 'hôte ou invité',
      secondaryCta: 'J’ai déjà un compte',
    },
    closeAuthDialog: 'Fermer la fenêtre d’authentification',
  },
  dashboard: {
    layoutTitle: `${APP_NAME} - Mes maisons`,
    title: 'Mes maisons',
    subtitle: 'Passez entre vos maisons hôte et invité, puis accédez au guide, aux activités et aux infos utiles.',
    collectionLabel: 'Votre sélection',
    hostingLabel: 'Hôte',
    visitingLabel: 'Invité',
    openHouse: 'Ouvrir la maison',
    createNewHouse: 'Créer une nouvelle maison',
    noDescription: 'Aucune description disponible',
    noHouses: 'Aucune maison pour le moment',
    noHousesDescription: 'Créez votre première maison pour commencer',
    createFirstHouse: 'Créer votre première maison',
    hosted_one: 'Hôte ({{count}})',
    hosted_other: 'Hôte ({{count}})',
    guest_one: 'Invité ({{count}})',
    guest_other: 'Invité ({{count}})',
    failedFetch: 'Impossible de récupérer les maisons',
    failedDelete: 'Impossible de supprimer la maison',
    menuEdit: 'Modifier',
    menuDelete: 'Supprimer',
    deleteTitle: 'Supprimer la maison',
    deleteMessage:
      'Voulez-vous vraiment supprimer cette maison ? Cette action est irréversible et supprimera aussi les articles, activités et réservations associés.',
  },
  houseDialog: {
    editTitle: 'Modifier la maison',
    createTitle: 'Créer une nouvelle maison',
    addPhotos: 'Ajouter des photos',
    addMorePhotos: 'Ajouter plus de photos',
    remove: 'Retirer',
    failedSave: "Impossible d'enregistrer la maison",
    maxOccupants: "Nombre maximum d'occupants",
    shortDescriptionHelper: 'Affichée sur la photo de la maison. Restez concis.',
  },
  houseDetail: {
    backToDashboard: 'Mes maisons',
    backToHouse: 'Retour à la maison',
    failedFetch: 'Impossible de récupérer les détails de la maison',
    notFound: 'Maison introuvable',
    inviteGuest: 'Inviter une personne',
    layoutTitle: `${APP_NAME} - {{name}}`,
    browseSections: 'Parcourez le guide, les activités, le calendrier et les espaces partagés depuis une page destination.',
    dashboardLabel: 'Tableau de bord de la maison',
    dashboardTitle: 'Explorer les espaces de la maison',
    hostedBy: 'Hôte',
    sharedWith: 'Partagée avec',
    quickActions: 'Actions rapides',
    quickActionsTitle: 'Aller plus vite dans cette maison',
    quickActionsDescription: 'Accédez directement aux actions les plus fréquentes de gestion et d\'organisation.',
    categories: {
      guideActivities: {
        title: 'Guide et activités',
        description: 'Consignes de la maison, activités, commerces et bonnes adresses pour organiser facilement chaque séjour.',
      },
      calendarReservations: {
        title: 'Calendrier et reservations',
        description: 'Disponibilités, demandes de séjour, prochains passages et gestion des réservations.',
      },
      other: {
        title: 'Autres',
        description: 'Contacts, problèmes, liste de souhaits et gestion des membres au même endroit.',
      },
    },
    actions: {
      openCalendar: 'Ouvrir le calendrier',
      reportProblem: 'Signaler un problème',
      manageMembers: 'Gérer les membres',
    },
    sections: {
      reservations: 'Reservations',
      reservationsDescription:
        'Consultez les demandes de séjour et les prochains passages depuis les outils du calendrier ci-dessous. Cette section garde la gestion des réservations avec les disponibilités.',
      members: 'Membres',
      membersDescription:
        'Retrouvez toutes les personnes qui ont accès à cette maison et gérez les invitations depuis le même espace.',
    },
    reservationSummary: {
      pending: 'Demandes en attente',
      approved: 'Séjours confirmés',
      blocked: 'Périodes bloquées',
    },
    tabs: {
      guide: 'Guide',
      activities: 'Activités',
      shops: 'Commerces',
      restaurants: 'Restaurants',
      calendar: 'Calendrier',
      wishlist: 'Liste de souhaits',
      problems: 'Problèmes',
      contacts: 'Contacts',
    },
  },
  inviteGuest: {
    title: "Inviter quelqu'un dans {{houseName}}",
    emailAddress: 'Adresse email',
    helper: "Saisissez l'adresse email de la personne à inviter",
    accessRole: "Rôle d'accès",
    roleGuest: 'Accès invité',
    roleHost: 'Accès hôte',
    guestHelper: 'Les invités peuvent consulter la maison et utiliser les actions invité comme les demandes de séjour et les suggestions.',
    hostHelper: 'Les hôtes peuvent gérer le contenu de la maison, les invitations, les réservations, les contacts et les autres actions de gestion.',
    emptyEmail: 'Veuillez saisir une adresse email',
    success: 'Invitation envoyée avec succès !',
    failed: "Impossible d'envoyer l'invitation",
    sending: 'Envoi...',
    send: "Envoyer l'invitation",
  },
  guests: {
    empty: "Aucun membre pour le moment. Invitez quelqu'un à partager cette maison !",
    failedFetch: 'Impossible de récupérer les membres',
    failedRemove: 'Impossible de retirer le membre',
    removeTitle: 'Retirer un membre',
    removeMessage:
      'Voulez-vous vraiment retirer {{name}} en tant que {{role}} de cette maison ? Cette personne perdra l\'accès correspondant.',
    removeInvitationMessage:
      "Voulez-vous vraiment annuler l'invitation en attente de type {{role}} pour {{name}} ?",
    failedResend: "Impossible de renvoyer l'invitation",
    resent: "L'email d'invitation a été renvoyé",
    removing: 'Suppression...',
    removeGuestAria: 'retirer un membre',
    resendInvitationAria: "renvoyer l'invitation",
  },
  invitationLanding: {
    layoutTitle: 'Invitation',
    failedFetch: "Impossible de charger l'invitation",
    failedAccept: "Impossible d'accepter l'invitation",
    failedReject: "Impossible de refuser l'invitation",
    notFound: 'Invitation introuvable',
    subtitle: 'Vous avez été invité à rejoindre {{houseName}} en tant que {{role}}.',
    location: 'Lieu',
    invitedEmail: 'Email invité',
    loginRequired: "Connectez-vous ou créez un compte avec cette adresse email pour répondre à l'invitation.",
    wrongAccount: 'Cette invitation est réservée à {{email}}. Connectez-vous avec ce compte pour répondre.',
    accepted: 'Cette invitation a déjà été acceptée.',
    rejected: 'Cette invitation a déjà été refusée.',
    login: 'Se connecter',
    register: 'Créer un compte',
    back: 'Retour',
  },
  invitations: {
    layoutTitle: 'Mes invitations',
    title: 'Invitations de maison',
    subtitle: 'Vous avez été invité à rejoindre ces maisons en tant qu\'hôte ou invité',
    empty: 'Aucune invitation en attente',
    emptyDescription: "Quand quelqu'un vous invitera à rejoindre une maison, elle apparaîtra ici",
    failedFetch: 'Impossible de récupérer les invitations',
    failedAccept: "Impossible d'accepter l'invitation",
    failedReject: "Impossible de refuser l'invitation",
    location: 'Lieu',
    invitedAs: 'Invité en tant que',
  },
  notifications: {
    layoutTitle: 'Notifications',
    title: 'Notifications',
    subtitle: 'Restez informé des invitations, réservations, problèmes et suggestions d\'activités de vos maisons.',
    failedFetch: 'Impossible de récupérer les notifications',
    empty: 'Aucune notification',
    emptyDescription: 'Quand quelque chose nécessitera votre attention, cela apparaîtra ici.',
    tabs: {
      all: 'Tout',
      invitations: 'Invitations',
      bookings: 'Réservations',
      problems: 'Problèmes',
      activities: 'Activités',
    },
    types: {
      invitation: 'Invitation',
      booking: 'Réservation',
      problem: 'Problème',
      activity: 'Activité',
    },
    invitationFrom: '{{name}} vous a invité à {{house}}',
    invitationForHouse: 'Invitation pour {{house}}',
    bookingRequest: '{{name}} a demandé un séjour à {{house}}',
    bookingRequestHouse: 'Demande de réservation pour {{house}}',
    bookingStatusChange: 'Votre réservation à {{house}} a été mise à jour',
    problemReported: '« {{title}} » signalé à {{house}}',
    problemReportedBy: '{{name}} a signalé « {{title}} » à {{house}}',
    problemStatusChange: '« {{title}} » à {{house}} a été mis à jour',
    activitySuggested: '« {{title}} » suggéré à {{house}}',
    activitySuggestedBy: '{{name}} a suggéré « {{title}} » à {{house}}',
    activityStatusChange: '« {{title}} » à {{house}} a été mis à jour',
  },
  articles: {
    layoutTitle: 'Guide de la maison - Articles',
    title: 'Guide de la maison',
    addArticle: 'Ajouter un article',
    noArticles: 'Aucun article pour le moment',
    noArticlesDescription: 'Créez votre premier article pour aider les invités à comprendre la maison',
    createFirst: 'Créer le premier article',
    failedFetch: 'Impossible de récupérer les articles',
    failedDelete: "Impossible de supprimer l'article",
    failedSave: "Impossible d'enregistrer l'article",
    deleteConfirm: 'Supprimer cet article ?',
    editTitle: "Modifier l'article",
    createTitle: 'Nouvel article',
    content: 'Contenu',
  },
  activities: {
    layoutTitle: 'Activités',
    title: 'Activités',
    addActivity: 'Ajouter une activité',
    suggestActivity: 'Suggérez une activité',
    noActivities: 'Aucune activité pour le moment',
    ownerEmpty: 'Ajoutez des activités et attractions autour de votre maison',
    guestEmpty: 'Suggérez une activité que le propriétaire pourra examiner',
    addFirst: 'Ajouter la première activité',
    suggestFirst: 'Suggérez la première activité',
    failedFetch: 'Impossible de récupérer les activités',
    failedDelete: "Impossible de supprimer l'activité",
    failedApprove: "Impossible d'approuver l'activité",
    failedReject: "Impossible de refuser l'activité",
    failedSave: "Impossible d'enregistrer l'activité",
    deleteConfirm: 'Supprimer cette activité ?',
    viewOnKomoot: 'Voir sur Komoot',
    editTitle: "Modifier l'activité",
    createTitle: 'Nouvelle activité',
    suggestTitle: 'Suggérez une activité',
    readyToUpload: 'Prêt à téléverser',
  },
  shops: {
    layoutTitle: 'Commerces',
    title: 'Commerces',
    addShop: 'Ajouter un commerce',
    noShops: 'Aucun commerce pour le moment',
    noShopsDescription: 'Listez les commerces et services utiles à proximité pour les invités',
    createFirst: 'Ajouter le premier commerce',
    failedFetch: 'Impossible de récupérer les commerces',
    failedDelete: 'Impossible de supprimer le commerce',
    failedSave: "Impossible d'enregistrer le commerce",
    deleteConfirm: 'Supprimer ce commerce ?',
    editTitle: 'Modifier le commerce',
    createTitle: 'Nouveau commerce',
    readyToUpload: 'Prêt à téléverser',
  },
  restaurants: {
    layoutTitle: 'Restaurants',
    title: 'Restaurants',
    addRestaurant: 'Ajouter un restaurant',
    noRestaurants: 'Aucun restaurant pour le moment',
    noRestaurantsDescription: 'Partagez les restaurants préférés autour de la maison pour les prochains séjours',
    createFirst: 'Ajouter le premier restaurant',
    failedFetch: 'Impossible de récupérer les restaurants',
    failedDelete: 'Impossible de supprimer le restaurant',
    failedSave: "Impossible d'enregistrer le restaurant",
    deleteConfirm: 'Supprimer ce restaurant ?',
    editTitle: 'Modifier le restaurant',
    createTitle: 'Nouveau restaurant',
    readyToUpload: 'Prêt à téléverser',
  },
  calendar: {
    layoutTitle: 'Calendrier et reservations',
    title: 'Calendrier et reservations',
    description: 'Voyez quand la maison est libre, occupée, ou bloquée par le propriétaire.',
    manageRules: 'Gérer les règles',
    blockPeriod: 'Bloquer une période',
    requestStay: 'Demander un séjour',
    noBookings: 'Aucune reservation pour le moment',
    noGuestRequests: 'Aucune demande de reservation pour le moment',
    requestFirstStay: 'Demander un premier séjour',
    requestYourFirstStay: 'Demandez votre premier séjour dans cette maison',
    failedFetch: 'Impossible de récupérer les réservations',
    failedDelete: 'Impossible de supprimer la reservation',
    failedApprove: "Impossible d'approuver la réservation",
    failedReject: 'Impossible de refuser la réservation',
    failedSave: "Impossible d'enregistrer la réservation",
    conflictUnavailable: 'Ce séjour entre en conflit avec des dates où la maison est indisponible.',
    conflictOutsideAvailability: 'Ce séjour est en dehors des dates actuellement ouvertes à la réservation.',
    conflictApprovedStay: 'Ce séjour entre en conflit avec une réservation déjà approuvée.',
    conflictTooFarAhead: 'Cette réservation est trop éloignée dans le futur.',
    failedSaveRules: "Impossible d'enregistrer les règles",
    failedSaveAvailability: "Impossible d'enregistrer la période indisponible",
    failedDeleteAvailability: 'Impossible de supprimer la période indisponible',
    deleteConfirm: 'Supprimer cette reservation ?',
    deleteUnavailableConfirm: 'Supprimer cette période indisponible ?',
    bookingRequest: 'Demande de reservation',
    editBooking: 'Modifier la reservation',
    newBooking: 'Nouvelle demande de reservation',
    request: 'Demander',
    rulesTitle: 'Règles de disponibilité',
    maxConsecutiveHelper: 'Nombre maximum de jours pour une reservation',
    maxBookingLeadHelper: "Nombre maximum de jours à l'avance pour réserver",
    maxGuestsHelper: "Nombre maximum d'invités autorisés",
    saveRules: 'Enregistrer les règles',
    monthOverview: 'Vue du mois',
    monthOverviewHelper: 'Sélectionnez un jour pour voir les réservations et les blocages du propriétaire.',
    selectionHintStart: "Cliquez sur un jour pour choisir votre date d'arrivée.",
    selectionHintEnd: 'Cliquez sur un jour pour choisir votre date de départ.',
    today: "Aujourd'hui",
    legendFree: 'Libre',
    legendBusy: 'Occupée',
    legendPending: 'En attente',
    legendBlocked: 'Bloquée',
    bookingsPanelTitle: 'Reservations et demandes',
    ownerBookingsHelper: 'Examinez les demandes des invités et les séjours confirmés.',
    guestBookingsHelper: 'Les séjours confirmés montrent quand la maison est occupée. Vos propres demandes restent modifiables.',
    unavailablePeriodsTitle: 'Périodes bloquées par le propriétaire',
    unavailablePeriodsHelper: 'Utilisez ces périodes quand la maison ne doit pas pouvoir être réservée.',
    noUnavailablePeriods: 'Aucune période bloquée pour le moment',
    unavailableDialogTitle: 'Ajouter une période indisponible',
    unavailableLabel: 'Libellé (optionnel)',
    unavailableLabelHelper: 'Exemple : maintenance, séjour familial, fermeture saisonnière',
    saveUnavailablePeriod: 'Enregistrer la période',
    blockedLabelFallback: 'Période indisponible du propriétaire',
    yourBooking: 'Votre reservation',
    houseBusy: 'Maison occupée',
    bookingDetailTitle: 'Réservations pour ce jour',
    hostResponse: 'Réponse du propriétaire',
    approveBookingTitle: 'Approuver la réservation',
    rejectBookingTitle: 'Refuser la réservation',
    respondMessageLabel: 'Message (optionnel)',
    respondMessagePlaceholder: 'Ajoutez un message pour l\'invité...',
    confirmApprove: 'Approuver',
    confirmReject: 'Refuser',
  },
  contacts: {
    layoutTitle: 'Contacts',
    title: 'Contacts importants',
    addContact: 'Ajouter un contact',
    noContacts: 'Aucun contact pour le moment',
    noContactsDescription: 'Ajoutez des contacts importants pour les urgences, la maintenance et les services locaux',
    addFirst: 'Ajouter le premier contact',
    failedFetch: 'Impossible de récupérer les contacts',
    failedDelete: 'Impossible de supprimer le contact',
    failedSave: "Impossible d'enregistrer le contact",
    deleteConfirm: 'Supprimer ce contact ?',
    editTitle: 'Modifier le contact',
    createTitle: 'Nouveau contact',
    categories: {
      emergency: 'Urgence',
      medical: 'Médical',
      practical: 'Pratique',
    },
  },
  wishlist: {
    layoutTitle: 'Liste de souhaits',
    title: 'Liste de souhaits',
    addItem: 'Ajouter un élément',
    noItems: 'Aucun élément dans la liste de souhaits',
    noItemsDescription: 'Ajoutez des éléments que les invités peuvent offrir',
    addFirst: 'Ajouter le premier élément',
    failedFetch: 'Impossible de récupérer la liste de souhaits',
    failedDelete: "Impossible de supprimer l'élément",
    failedUpdate: "Impossible de mettre à jour l'élément",
    failedSave: "Impossible d'enregistrer l'élément",
    deleteConfirm: 'Supprimer cet élément ?',
    viewProduct: 'Voir le produit',
    editTitle: "Modifier l'élément",
    createTitle: 'Nouvel élément',
  },
  problems: {
    layoutTitle: 'Problèmes',
    title: 'Problèmes connus',
    reportProblem: 'Signaler un problème',
    noProblems: 'Aucun problème signalé',
    noProblemsDescription: 'Signalez les pannes ou incidents pour informer les invités',
    reportFirst: 'Signaler le premier problème',
    failedFetch: 'Impossible de récupérer les problèmes',
    failedDelete: 'Impossible de supprimer le problème',
    failedSave: "Impossible d'enregistrer le problème",
    deleteConfirm: 'Supprimer ce problème ?',
    editTitle: 'Modifier le problème',
    createTitle: 'Signaler un problème',
  },
  bedrooms: {
    title: 'Chambres',
    addBedroom: 'Ajouter une chambre',
    addBed: 'Ajouter un lit',
    bedroomName: 'Nom de la chambre',
    bedroomPlaceholder: 'Chambre {{number}}',
    bedroomDefault: 'Chambre {{number}}',
    bedType: 'Type',
    dimensions: 'Taille',
    single: 'Lit simple',
    double: 'Lit double',
    summaryRooms_one: '{{count}} chambre',
    summaryRooms_other: '{{count}} chambres',
    summaryBeds_one: '{{count}} lit',
    summaryBeds_other: '{{count}} lits',
    summarySingle_one: '{{count}} simple',
    summarySingle_other: '{{count}} simples',
    summaryDouble_one: '{{count}} double',
    summaryDouble_other: '{{count}} doubles',
  },
  amenities: {
    title: 'Équipements',
    categories: {
      kitchen: 'Cuisine',
      laundry: 'Buanderie',
      bathroom: 'Salle de bain',
      climate: 'Chauffage et climatisation',
      entertainment: 'Divertissement',
      sports: 'Équipement sportif',
      outdoor: 'Extérieur',
      safety: 'Sécurité',
      connectivity: 'Travail',
      parking: 'Stationnement',
    },
    items: {
      oven: 'Four',
      microwave: 'Micro-ondes',
      dishwasher: 'Lave-vaisselle',
      fridge: 'Réfrigérateur',
      freezer: 'Congélateur',
      coffeeMaker: 'Cafetière',
      kettle: 'Bouilloire',
      toaster: 'Grille-pain',
      washingMachine: 'Lave-linge',
      dryer: 'Sèche-linge',
      iron: 'Fer à repasser',
      bathtub: 'Baignoire',
      shower: 'Douche',
      hairDryer: 'Sèche-cheveux',
      heating: 'Chauffage',
      airConditioning: 'Climatisation',
      fireplace: 'Cheminée',
      woodStove: 'Poêle',
      fan: 'Ventilateur',
      tv: 'Télévision',
      projector: 'Projecteur',
      speakers: 'Enceintes',
      wifi: 'Wi-Fi',
      boardGames: 'Jeux de société',
      books: 'Livres',
      comics: 'Bandes dessinées',
      billiards: 'Billard',
      gameConsole: 'Console de jeux',
      paddle: 'Paddle',
      canoe: 'Canoë',
      windsurf: 'Planche à voile',
      wingfoil: 'Wingfoil',
      garden: 'Jardin',
      terrace: 'Terrasse',
      bbq: 'Barbecue',
      pool: 'Piscine',
      hotTub: 'Jacuzzi',
      bikesAvailable: 'Vélos à disposition',
      hammock: 'Hamac',
      pingPongTable: 'Table de ping-pong',
      gardenFurniture: 'Mobilier de jardin',
      smokeDetector: 'Détecteur de fumée',
      firstAidKit: 'Trousse de secours',
      fireExtinguisher: 'Extincteur',
      workDesk: 'Bureau de travail',
      parking: 'Parking',
      garage: 'Garage',
      evCharger: 'Borne de recharge',
    },
  },
} as const;

export default fr;